import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const titles = {
  '/login': 'Вход',
  '/register': 'Регистрация',
  '/recoveryPassword': 'Восстановление пароля',
}

// ==============================|| LAYOUT - AUTH ||============================== //

export default function AuthLayout() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith('/recoveryPassword')) {
      document.title = 'Восстановление пароля';
      return;
    }
    const title = titles[pathname] || 'Авторизация';
    document.title = title;
  })
  return (
    <>
      <Outlet />
    </>
  );
}
